import React, { Suspense, lazy, useEffect, useState } from "react";
import LightTable from "../../components/components-bootstrap/LightTable";
import { useGetFetch } from "../../data/Queries";
import { trainerEndpoint, trainersGetKey } from "../../data/ApiEndpoints";
import { useDispatch, useSelector } from "react-redux";
import { selectAuth, selectToken } from "../../components/auth/auth.selector";
import Loader from "../../components/ui/Loader";
import { formatDate } from "../../utils/utilityfunc";
import PaginationLight from "../../components/components-bootstrap/PaginationLight";
import ReactModal from "react-modal";
// import { RxCross1 } from "react-icons/rx";
import FilterBlock from "../../components/FilterBlock";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../data/APIs";
import "../../styles/feedback/feedback.css";
import HelmetWrapper from "../../HelmetWrapper.js";

const Feedbacks = lazy(() =>
  import("../../components/trainerFeedback/Feedbacks.jsx")
);

const TrainerFeedback = () => {
  const token = useSelector(selectToken);
  const gymData = useSelector(selectGymData);
  const dispatch = useDispatch();

  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};
  const isAdmin = user?.account_type === "admin";

  const [viewAllModal, setViewAllModal] = useState({
    status: false,
    data: null,
  });
  const [trainerFilters, setTrainerFilters] = useState({
    gym_id: !isAdmin ? user?.gym_id || user?.uid : "",
  });
  const [isPage, setIsPage] = useState(0);
  const {
    data: trainersData,
    isLoading: isLoadingTrainers,
    isFetching: isFetchingTrainers,
    refetch: refetchTrainers,
  } = useGetFetch({
    url: trainerEndpoint,
    key: trainersGetKey,
    filters: { ...trainerFilters, limit: 5 },
    isPage: isPage + 1,
    token,
  });

  function handleViewAllFeedback(row) {
    try {
      setViewAllModal({
        status: true,
        data: row,
      });
    } catch (error) {
      console.log(error);
    }
  }

  function isLoading() {
    try {
      if (isLoadingTrainers || isFetchingTrainers) {
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    }
  }

  const allFilters = [
    {
      id: 0,
      label: "Gym",
      name: "gym_id",
      options: gymData,
    },
  ];

  useEffect(() => {
    try {
      refetchTrainers();
    } catch (error) {
      console.log(error);
    }
  }, [trainerFilters, isPage]);

  useEffect(() => {
    try {
      dispatch(fetchGymData(token));
    } catch (error) {
      console.log(error);
    }
  }, []);

  const col = [
    // {
    //   dataField: "wtf_trainer",
    //   text: "Type",
    //   formatter: (type) => {
    //     return (
    //       <div className="flex-k">
    //         <span>{type === 1 ? "WTF" : "Gym"}</span>
    //       </div>
    //     );
    //   },
    // },
    {
      dataField: "name",
      text: "Name",
      formatter: (name, row) => {
        return (
          <div className="flex-k flex-col-k items-start-k">
            <span className="fs-small-k bold-text">{name}</span>
            <span className="fs-smaller-k">{row?.email}</span>
            <span className="fs-smaller-k">{row?.mobile}</span>
          </div>
        );
      },
    },
    {
      dataField: "reporting_to_name",
      text: "Reporting To",
      formatter: (reporting_to_name) => {
        return (
          <div className="flex-k">
            <span>{reporting_to_name || "N/A"}</span>
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (gym) => {
        return (
          <div
            style={{
              maxWidth: "300px",
            }}
            className="flex-k gym-container"
          >
            <span>{gym || "N/A"}</span>
          </div>
        );
      },
    },
    {
      dataField: "trainer_category",
      text: "Category",
      formatter: (category) => {
        return <span>{category || "N/A"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (date) => {
        return (
          <div className="flex-k">
            <span>{formatDate(new Date(Number(date) * 1000))}</span>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (status) => {
        const isActive = status === "active";
        return (
          <div className="flex-k">
            <span
              className={`badge text-capitalize fs-6 ${
                isActive ? "bg-success" : "bg-danger"
              }`}
            >
              {status}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "",
      text: "Feedback",
      formatter: (_, row) => {
        return (
          <div className="flex-k">
            <button
              className="btn-k btn-muted-k small"
              onClick={() => handleViewAllFeedback(row)}
            >
              View
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Tranier Feedback">
      <div className="feedback">
        <header>
          <h2 className="bold-text">Trainer Feedback</h2>
        </header>
        <FilterBlock
          isSearch={{ placeholder: "Search by Name.." }}
          allFilters={allFilters}
          setFilters={setTrainerFilters}
        />
        {isLoading() ? (
          <div className="flex-k js-center-k items-center-k h-50vh-k">
            <Loader />
          </div>
        ) : (
          <>
            <LightTable columns={col} data={trainersData?.data || []} />
            <div className="flex-k">
              <PaginationLight
                isPage={isPage}
                onChangePage={setIsPage}
                pagination={trainersData?.pagination || []}
              />
            </div>
          </>
        )}

        <ReactModal ariaHideApp={false} isOpen={viewAllModal?.status}>
          <div className="modal-body-k bg-white rounded-5">
            <div className="p-2 py-3">
              <header className="flex-k js-between-k items-center-k">
                <h3>All Feedbacks of the Trainer</h3>
                <button
                  className="btn-k small btn-muted-k rounded-full-k"
                  onClick={() => setViewAllModal({ status: false, data: null })}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                  </svg>
                  {/* <RxCross1 size={22} /> */}
                </button>
              </header>
            </div>
            <div>
              <Suspense fallback={<Loader />}>
                <Feedbacks trainerData={viewAllModal?.data} />
              </Suspense>
            </div>
          </div>
        </ReactModal>
      </div>
    </HelmetWrapper>
  );
};

export default TrainerFeedback;
